import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAddIdentityProviderRequestFailure() {
      return getState().isFailure;
    },
    isAddIdentityProviderRequestPending() {
      return getState().isPending;
    },
    isAddIdentityProviderRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
